import { Button } from '@jouzen/ecom-components/v3/Button';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import { useAddOnBundleContext } from '@/app/[locale]/meta/_contexts/AddOnBundleProvider';

const ModalFixedFooter = () => {
  const { proceedButtonText, isAddingToCart, onAddToCart } =
    useAddOnBundleContext();
  const t = useTranslations();
  return (
    <div
      className="flex justify-end border-t border-sandstone-500/50 bg-sandstone-100 pt-4"
      data-cy="bundle-fixed-footer"
    >
      <Button
        className={cx(
          'border-[1px] border-solid border-sandstone-500 whitespace-nowrap',
          {
            'bg-[#4A4741]/8 text-sandstone-500 md:bg-transparent md:hover:bg-[#4A4741]/8':
              proceedButtonText === 'bundle_modal_skip_button',
          },
        )}
        data-cy={`bundle_${proceedButtonText}`}
        onClick={onAddToCart}
        loading={isAddingToCart}
        loadingTextEnabled
        size="large"
        type="submit"
        variant="secondary-dark"
      >
        {t(proceedButtonText)}
      </Button>
    </div>
  );
};
export default ModalFixedFooter;
